export const DEVICE_TYPES = {
  MOBILE: "Mobile",
  WATCH: "Watch",
};

/** Static sign-in code lifetime fallback (5 minutes). */
export const SIGN_IN_CODE_EXPIRY_SECONDS = 5 * 60;

export const INITIAL_LAST_SYNCED = "—";

const formatDisplayValue = (value) => {
  if (value === null || value === undefined || value === "") return null;
  return value;
};

/** Formats version values as "V 5.37". */
const formatVersion = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const raw = String(value).trim();
  if (!raw) return null;
  return /^v\s*/i.test(raw) ? raw.replace(/^v\s*/i, "V ") : `V ${raw}`;
};

const formatTimestamp = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const num = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(num)) return formatDisplayValue(value);

  // Most timestamps in the screenshot look like epoch milliseconds (e.g. 1782994509164)
  const ms = num > 1e12 ? num : num * 1000;
  const d = new Date(ms);
  if (Number.isNaN(d.getTime())) return formatDisplayValue(value);

  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

/**
 * Maps /web/patient/device/latest payload into UI device fields.
 */
export const mapLatestDeviceToView = (payload = {}, fallbackType) => {
  const resolvedType =
    payload.deviceType ||
    (payload.acumaAppType === "W"
      ? DEVICE_TYPES.WATCH
      : payload.acumaAppType === "M"
        ? DEVICE_TYPES.MOBILE
        : fallbackType);

  return {
    deviceType: resolvedType || fallbackType,
    manufacturer: formatDisplayValue(payload.manufacturer),
    modelName: formatDisplayValue(
      payload.modelName || payload.model || payload.deviceModel,
    ),
    os: formatDisplayValue(
      payload.os ||
        (payload.osName
          ? `${payload.osName}${payload.osVersion ? ` ${payload.osVersion}` : ""}`
          : payload.osVersion),
    ),
    appVersion: formatVersion(payload.appVersion),
    osApiLevel: formatVersion(payload.osApiLevel),
    oemUi: formatDisplayValue(payload.oemUi || payload.oemUiName),
    oemUiVersion: formatVersion(
      payload.oemUiVersion || payload.oemUiVersionName,
    ),
    lastLogin: formatTimestamp(payload?.latestSession?.loginAt),
    lastLogout: formatTimestamp(payload?.latestSession?.endedAt),
    lastActivity: formatTimestamp(payload?.latestSession?.lastActivityAt),
    lastSynced: formatTimestamp(payload.updatedAt),
  };
};

export const buildDeviceDetailItems = (device = {}) => [
  { label: "Device Type", value: device.deviceType },
  { label: "Manufacturer", value: device.manufacturer },
  { label: "Model", value: device.modelName },
  { label: "OS", value: device.os },
  { label: "App Version", value: device.appVersion },
  { label: "OS API Level", value: device.osApiLevel },
  { label: "OEM UI", value: device.oemUi },
  { label: "OEM UI Version", value: device.oemUiVersion },
  { label: "Last Login", value: device.lastLogin },
  { label: "Last Logout", value: device.lastLogout || "—" },
  { label: "Last Activity", value: device.lastActivity, fullWidth: true },
];
